import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { LeafletDirective, LeafletDirectiveWrapper } from '@asymmetrik/ngx-leaflet';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@asymmetrik/ngx-leaflet';
var LeafletMarkerClusterDirective = /** @class */ (function () {
    function LeafletMarkerClusterDirective(leafletDirective) {
        // Hexbin data binding
        this.markerData = [];
        // Fired when the marker cluster is created
        this.markerClusterReady = new EventEmitter();
        this.leafletDirective = new LeafletDirectiveWrapper(leafletDirective);
    }
    LeafletMarkerClusterDirective.prototype.ngOnInit = function () {
        this.leafletDirective.init();
        var map = this.leafletDirective.getMap();
        this.markerClusterGroup = L.markerClusterGroup(this.markerClusterOptions);
        // Add the marker cluster group to the map
        this.markerClusterGroup.addTo(map);
        // Set the data now that the markerClusterGroup exists
        this.setData(this.markerData);
        // Fire the ready event
        this.markerClusterReady.emit(this.markerClusterGroup);
    };
    LeafletMarkerClusterDirective.prototype.ngOnChanges = function (changes) {
        // Set the new data
        if (changes['markerData']) {
            this.setData(this.markerData);
        }
    };
    LeafletMarkerClusterDirective.prototype.setData = function (layers) {
        // Ignore until the markerClusterGroup exists
        if (null != this.markerClusterGroup) {
            this.markerClusterGroup.clearLayers();
            this.markerClusterGroup.addLayers(layers);
        }
    };
    LeafletMarkerClusterDirective.ctorParameters = function () { return [
        { type: LeafletDirective }
    ]; };
    LeafletMarkerClusterDirective.propDecorators = {
        markerData: [{ type: Input, args: ['leafletMarkerCluster',] }],
        markerClusterOptions: [{ type: Input, args: ['leafletMarkerClusterOptions',] }],
        markerClusterReady: [{ type: Output, args: ['leafletMarkerClusterReady',] }]
    };
LeafletMarkerClusterDirective.ɵfac = function LeafletMarkerClusterDirective_Factory(t) { return new (t || LeafletMarkerClusterDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LeafletDirective)); };
LeafletMarkerClusterDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LeafletMarkerClusterDirective, selectors: [["", "leafletMarkerCluster", ""]], inputs: { markerData: ["leafletMarkerCluster", "markerData"], markerClusterOptions: ["leafletMarkerClusterOptions", "markerClusterOptions"] }, outputs: { markerClusterReady: "leafletMarkerClusterReady" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LeafletMarkerClusterDirective, [{
        type: Directive,
        args: [{
                selector: '[leafletMarkerCluster]'
            }]
    }], function () { return [{ type: ɵngcc1.LeafletDirective }]; }, { markerData: [{
            type: Input,
            args: ['leafletMarkerCluster']
        }], markerClusterReady: [{
            type: Output,
            args: ['leafletMarkerClusterReady']
        }], markerClusterOptions: [{
            type: Input,
            args: ['leafletMarkerClusterOptions']
        }] }); })();
    return LeafletMarkerClusterDirective;
}());
export { LeafletMarkerClusterDirective };

//# sourceMappingURL=leaflet-markercluster.directive.js.map